export const isChatActive = () => {
  if (localStorage.getItem('ca-session') === 'active') return true;
  return false;
};
